import { render, staticRenderFns } from "./Checkmark12px.vue?vue&type=template&id=2ad78702&"
import script from "./Checkmark12px.vue?vue&type=script&lang=js&"
export * from "./Checkmark12px.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports